module.exports = __webpack_public_path__ + "img/jon-Paused.cb4dabc2.svg";